import {Company} from "./company";
import {Permission} from "./permission";
import {http} from './http'
import { secureLocalStorageGet } from "../helpers";

export interface User {
    auth_token: string;
    auth_token_verifyed: string;
    customerData : Company[];
    currentCompany : Company;
    permissions : Permission[],
    userName : string,
    usersSurName : string;
    lang: string;
    role: number;
    isTOTPEnabled? : boolean;
    totalApproverCount? : number;
    totalSignerCount? : number;
};

export const getUserData = () => {
    // const userData:object=JSON.parse(localStorage.getItem('userData') || '{}');
    const userData:any=secureLocalStorageGet('userData') || {};
    return <User>userData;
}
export const getRoleData = () => {
    // const roleData:object=JSON.parse(localStorage.getItem('rol')) || '';
    const roleData:any=secureLocalStorageGet("rol") || '';
    return <Number>roleData;
}

export const getCurrentCompany = () => {
    // const currentCompany:object=JSON.parse(localStorage.getItem('currentCompany') || localStorage.getItem('currentCompany') || '{}');

    const currentCompany:any= secureLocalStorageGet("currentCompany") || {};
    return <Company>currentCompany;
}

export const getUserAuthToken = () => {
    const auth_token:string=(localStorage.getItem('auth_token') || '');
    return <User><unknown>auth_token;
}

export const getUserAuthTokenVerified = () => {
    const auth_token_verifyed:string = localStorage.getItem('auth_token_verifyed') || '';
    return <User><unknown>auth_token_verifyed;
}

export const getLangData = () => {
    const lang:string=(localStorage.getItem('lang') || 'az');
    return <string><unknown>lang;
}
export type activeCompanyData = {
    customerNo: string,
}

export interface FavCompany {
    customerNo: string;
    result: any;
};

export const addActiveCompany = async (customerNo: activeCompanyData): Promise<User[]> => {
    const { data } = await http.post<User[]>('auth/setcustomer',customerNo);
    return data;
};

  export const setFavCompany = async (customerNo: FavCompany): Promise<FavCompany> => {
    const { data } = await http.post<FavCompany>("auth/set-fav-customer", customerNo);
    return data;
};
